function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  position: relative;\n\n  .columns {\n    height: 100%;\n    display: flex;\n    align-items: stretch;\n\n    > div {\n      flex: 0 0 90px;\n      & + div {\n        flex: 1 1 0;\n        border-left: 1px dashed black;\n      }\n\n      div {\n        height: 48px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #f8f8fa;\n        border-top: 1px solid #d3d7dc;\n        border-bottom: 1px solid #d3d7dc;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useMemo, useState } from "react";
import propTypes from "prop-types";
import safeGet from "lodash/get";
import styled from "styled-components";
import { getElementWindowTop, getChartSpecs } from "../utils";
function ChartSection(props) {
    var itemGroups = props.itemGroups, phaseLabelPositions = props.phaseLabelPositions, rest = _objectWithoutProperties(props, [
        "itemGroups",
        "phaseLabelPositions"
    ]);
    var ref = _slicedToArray(useState(0), 2), containerTop = ref[0], setContainerTop = ref[1];
    var ref1 = useMemo(function() {
        return getChartSpecs(itemGroups);
    }, [
        itemGroups
    ]), totalWeeks = ref1.totalWeeks, barGroups = ref1.barGroups;
    return /*#__PURE__*/ React.createElement("div", _extends({}, rest, {
        ref: function(dom) {
            if (dom) setContainerTop(getElementWindowTop(dom));
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "columns"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", null, "Weeks")), Array.from({
        length: totalWeeks
    }).map(function(_, i) {
        return /*#__PURE__*/ React.createElement("div", {
            key: i
        }, /*#__PURE__*/ React.createElement("div", null, i + 1));
    })), !!phaseLabelPositions.length && barGroups.map(function(bg, i) {
        var indexPath = bg.indexPath, startWeek = bg.startWeek, weekCounts = bg.weekCounts, color = bg.color, weekBarIndexes = bg.weekBarIndexes;
        var currentWeek = startWeek;
        return weekCounts.map(function(weekCount, wi) {
            var style = {
                position: "absolute",
                left: "calc(90px + (100% - 90px) * ".concat(currentWeek / totalWeeks, ")"),
                width: "calc((100% - 90px) * ".concat(weekCount / totalWeeks, ")"),
                backgroundColor: color,
                height: 0,
                top: 0
            };
            currentWeek += weekCount;
            var labelSpecs = safeGet(phaseLabelPositions, _toConsumableArray(indexPath).concat([
                weekBarIndexes[wi]
            ]));
            if (labelSpecs) {
                style.height = labelSpecs.height;
                style.top = labelSpecs.top + labelSpecs.height / 2 - containerTop - style.height / 2;
            }
            return /*#__PURE__*/ React.createElement("div", {
                key: "".concat(i, ":").concat(wi),
                style: style
            });
        });
    }));
}
var StChartSection = styled(ChartSection)(_templateObject());
ChartSection.propTypes = {
    itemGroups: propTypes.array.isRequired,
    phaseLabelPositions: propTypes.arrayOf(propTypes.arrayOf(propTypes.arrayOf(propTypes.any)))
};
export default StChartSection;
